type AddressStreetInfoSingleFieldVariantProps = {
  postcode: string;
  streetName: string;
  streetAdditional: string;
};

export const AddressStreetInfoSingleFieldVariant = ({
  postcode,
  streetName,
  streetAdditional,
}: AddressStreetInfoSingleFieldVariantProps) => (
  <>
    <div>{postcode}</div>
    <div>{streetName},</div>
    <div>{streetAdditional}</div>
  </>
);
